import React from 'react';

// Components
import FeedbackAndKudosSection from './FeedbackAndKudosSection/FeedbackAndKudosSection';

type Props = {
  pageRef?: {
    current: HTMLDivElement;
  };
};

const WorkspaceFeedbackTab = ({ pageRef }: Props) => {
  return (
    <div style={{ height: '100%' }}>
      <FeedbackAndKudosSection pageRef={pageRef} />
    </div>
  );
};

export default WorkspaceFeedbackTab;
